import { ConfigByClient, ConfigByTenant } from "resbutler-utils/types";

let configuration: ConfigByClient | ConfigByTenant = null;

export function initUI(config: ConfigByClient | ConfigByTenant) {
  configuration = config;
}

export function getConfigUI(): ConfigByClient | ConfigByTenant {
  if (!configuration) throw new Error("ui not init");
  return configuration;
}
